import { Select, SelectProps } from '@mantine/core';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ResetButton } from 'shared/components/buttons/ResetButton/ResetButton';

import { FormControl } from '../../../../../../components/controlledPanels/FormControl/FormControl';
import { TooltipProps } from '../../Tooltip.types';
import { DEFAULT_POSITION, TOOLTIP_POSITION } from '../../consts';
import type { TooltipConfigProps } from '../TooltipConfig';

export function Position(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, onUpdateStyle } = props;
  const { t } = useTranslation('components.theme.settings');

  const setPosition = useCallback(
    (newPosition: TooltipProps['position']) => onUpdateStyle({ position: newPosition }),
    [onUpdateStyle]
  );

  return (
    <FormControl title={t('position')}>
      <Select
        data={TOOLTIP_POSITION}
        value={styles.position ?? DEFAULT_POSITION}
        onChange={setPosition as SelectProps['onChange']}
      />
      {styles.position && <ResetButton onClick={() => onRemoveStyle('position')} />}
    </FormControl>
  );
}
